import React, { useMemo } from 'react';

import { DefaultControlPanel, PolygonControlPanel, RectangleControlPanel } from './control-panel/index.js';

export const RegionControlPanel = (props) => {
  const controlPanel = useMemo(() => {
    const { type, figure } = props?.regionData ?? {};
    switch (type) {
      case 'roi': return <RectangleControlPanel {...props} />;
      // point3: прямоугольный DROI редактируется как прямоугольник (панель координат),
      // полигональный — как полигон
      case 'droi': return figure === 'rect'
        ? <RectangleControlPanel {...props} />
        : <PolygonControlPanel {...props} />;
      default: return <DefaultControlPanel {...props} />;
    }
  }, [props]);

  const { mediaSize } = props ?? {};
  if (!mediaSize?.width) return null;

  return controlPanel;
};
